export enum PurchaseOrderStatus {
  NEW = 'New',
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}
